<template>
  <div class="admin-layout d-flex">
    <admin-sidebar />
    <div class="admin-content flex-grow-1">
      <admin-topbar />
      <div class="container-fluid py-4 px-lg-4 px-3">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import AdminSidebar from "../components/AdminSidebar.vue";
import AdminTopbar from "../components/AdminTopbar.vue";

export default {
  name: "AdminLayout",
  components: {
    AdminSidebar,
    AdminTopbar
  }
};
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
  background: #f5fbff;
}

.admin-content {
  min-width: 0;
}
</style>

